import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/phone-icon.svg")